import { useCallback, useEffect, useState } from 'react';
import type { AppWorkSummary } from '@shared/types/thread-work';
import { supabase } from './supabase';
import { toDashboardUiError } from './dashboard-errors';

/** A4: apps with open work outside any account, ranked by the server. */
export const listAppWork = async (memberUserId?: string): Promise<AppWorkSummary[]> => {
  const { data, error } = await supabase.functions.invoke('activity-feed', {
    body: { action: 'list_app_work', ...(memberUserId ? { memberUserId } : {}) },
  });
  if (error) throw new Error((await toDashboardUiError(error, 'Le travail hors compte n’a pas pu être chargé.')).message);
  const apps = (data as { apps?: unknown } | null)?.apps;
  return Array.isArray(apps) ? apps as AppWorkSummary[] : [];
};

export const useAppWorkList = () => {
  const [apps, setApps] = useState<AppWorkSummary[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [reloadKey, setReloadKey] = useState(0);
  useEffect(() => {
    let active = true;
    void listAppWork()
      .then((value) => { if (active) { setApps(value); setError(null); } })
      .catch((cause: unknown) => {
        if (active) setError(cause instanceof Error ? cause.message : 'Le travail hors compte n’a pas pu être chargé.');
      });
    return () => { active = false; };
  }, [reloadKey]);
  const reload = useCallback(() => setReloadKey((key) => key + 1), []);
  return { apps, error, reload };
};
